import 'bootstrap';
import * as bootstrap from "bootstrap";

import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

// Ensure LightGallery CSS is included
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-zoom.css';

    document.addEventListener('DOMContentLoaded', function () {
    const toggleMap = document.getElementById('toggleMap');
    const mapContainer = document.getElementById('mapContainer');
    const propertiesContainer = document.getElementById('propertiesContainer');
    const propertyList = document.getElementById('propertyList');
    /*const filterSidebar = document.getElementById('filterSidebar');
    const closeFilterSidebar = document.getElementById('closeFilterSidebar');*/

    toggleMap.addEventListener('change', function () {
    if (toggleMap.checked) {
    mapContainer.style.display = 'block';
    propertiesContainer.classList.remove('col-12');
    propertiesContainer.classList.add('col-lg-8');
} else {
    mapContainer.style.display = 'none';
    propertiesContainer.classList.remove('col-lg-8');
    propertiesContainer.classList.add('col-12');
}
});

    // Initial setup based on checkbox state
    if (!toggleMap.checked) {
    mapContainer.style.display = 'none';
    propertiesContainer.classList.remove('col-lg-8');
    propertiesContainer.classList.add('col-12');
}

    // Prevent form submission inside the sidebar from closing the sidebar
/*    document.querySelectorAll('#filterSidebar form').forEach(form => {
        form.addEventListener('submit', function (event) {
            event.stopPropagation();
        });
    });*/

    // Adjust height
    function adjustHeight() {
    const newHeight = window.innerHeight * 0.8;
    mapContainer.style.height = newHeight + 'px';
    propertiesContainer.style.height = newHeight + 'px';
}
    adjustHeight();
    window.addEventListener('resize', adjustHeight);
});
/*document.addEventListener('DOMContentLoaded', function() {
    const filterSidebar = document.getElementById('filterSidebar1');
    const closeFilterSidebar = document.getElementById('closeFilterSidebar');
    const showFilterBtn = document.getElementById('show-filters-btn');

    showFilterBtn.addEventListener('click', function(e) {
        e.stopPropagation(); // Prevent click event from propagating to the document
        filterSidebar.classList.remove('d-none');
    });

    closeFilterSidebar.addEventListener('click', function(e) {
        filterSidebar.classList.add('d-none');
    });

    document.addEventListener('click', function(e) {
        const isClickInside = filterSidebar.contains(e.target) || showFilterBtn.contains(e.target);
        if (!isClickInside) {
            filterSidebar.classList.add('d-none');
        }
    });
});*/


    document.addEventListener('DOMContentLoaded', function() {
        function setupMultiSelect(dropdown, placeholderText, requestValues) {
            const dropdownBtn = dropdown.querySelector('.dropdown-btn');
            const dropdownContent = dropdown.querySelector('.dropdown-content');
            const dropdownPlaceholder = dropdown.querySelector('span');

            if (dropdownBtn && dropdownContent && dropdownPlaceholder) {
                dropdownBtn.addEventListener('click', function() {
                    dropdownContent.classList.toggle('show');
                });

                document.addEventListener('click', function(e) {
                    if (!dropdownBtn.contains(e.target) && !dropdownContent.contains(e.target)) {
                        dropdownContent.classList.remove('show');
                    }
                });

                const updatePlaceholder = () => {
                    const selected = [];
                    dropdownContent.querySelectorAll('input[type="checkbox"]:checked').forEach(checkbox => {
                        selected.push(checkbox.value);
                    });
                    dropdownPlaceholder.textContent = selected.length ? selected.join(', ') : placeholderText;
                };

                dropdownContent.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                    checkbox.addEventListener('change', updatePlaceholder);
                });

                // Ensure preselected checkboxes based on the request and update the placeholder
                requestValues.forEach(value => {
                    const checkbox = dropdown.querySelector(`input[value="${value}"]`);
                    if (checkbox) {
                        checkbox.checked = true;
                    }
                });
                updatePlaceholder();
            } else {
                console.error('Elements not found for:', dropdown, placeholderText);
            }
        }

        document.querySelectorAll('.multi-select-dropdown').forEach(dropdown => {
            const placeholderText = dropdown.getAttribute('data-placeholder');
            const requestValues = JSON.parse(dropdown.getAttribute('data-values'));
            setupMultiSelect(dropdown, placeholderText, requestValues);
        });
    });


    $(document).ready(function() {
    function matchHeight() {
        var mapHeight = $('#map').height();
        $('#filterAccordion').height(mapHeight);
    }

    matchHeight();
    $(window).resize(function() {
    matchHeight();
});
});

/*MAIN MAP*/
/*MAIN MAP*/
/*MAIN MAP*/
/*MAIN MAP*/
/*MAIN MAP*/
/*MAIN MAP*/
/*MAIN MAP*/
/*function filterProperties() {
    const propertyType = document.getElementById('propertyTypeFilter').value;
    console.log('Filtering properties for type:', propertyType);

    clearMarkers();
    const filteredProperties = propertyType ? properties.filter(property => property.property_type_id == propertyType) : properties;

    if (filteredProperties.length === 0) {
        console.log('No properties found');
        return;
    }
    filteredProperties.forEach(property => {
        console.log('Property:', property.name, 'Lat:', property.latitude, 'Lng:', property.longitude);
        addMarker(property);
    });
}*/



/*MODAAAAAAALLLLLLL*/
 /*MODAAAAAAALLLLLLL*/
 /*MODAAAAAAALLLLLLL*/
 /*MODAAAAAAALLLLLLL*/
 /*MODAAAAAAALLLLLLL*/
 /*MODAAAAAAALLLLLLL*/
/*import $ from 'jquery';

window.$ = $;
window.jQuery = $;*/

function initializeScrollNavbar() {
    const scrollContainer = document.querySelector('.col-lg-6.col-md-6.col-sm-12.px-3');

    document.querySelectorAll('.navbar-nav .nav-link').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                scrollContainer.scrollTo({
                    top: targetElement.offsetTop - 140,
                    behavior: 'smooth'
                });
            }
        });
    });
}
